import { gql } from '@apollo/client';

export const EXPORT_USER_WORKSPACE_FORM_SUBMISSIONS = gql`
  query ExportUserWorkspaceFormSubmissions($input: GetMyFormInput!) {
    submissions: exportUserWorkspaceFormSubmissions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          updatedAt
          status
          createdAt
          statusDate
          status
          respondent {
            id
            lastName
            firstName
          }
          userRespondent {
            id
            lastName
            firstName
          }
          # CSV cells take the raw answer, so the file's URL is both cheaper and more useful than a
          # multi-megabyte base64 blob.
          data(inlineFiles: false) {
            id
            answer
            question {
              id
              name
            }
          }
          workspaceForm {
            id
            template {
              jsonData
            }
          }
        }
      }
    }
  }
`;
